import React from "react";
import "./InfoPopup.scss";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const InfoPopup = ({ mainTitle, dataInfo = [] }) => {
  return (
    <div className="info-popup-wrapper">
      <div className="info-popup-maintitle">
        {<FormattedMessage id={mainTitle} defaultMessage={mainTitle} />}
      </div>
      {dataInfo.length > 0 &&
        dataInfo.map((section) => {
          return (
            <div key={section} className="info-popup-subwrapper">
              <hr />
              <div className="info-popup-subtitle">
                <FormattedMessage
                  id={section?.main_title}
                  defaultMessage={section?.title}
                />
              </div>
              <div className="info-popup-subtitle_desc">
                {section?.main_title_description && (
                  <FormattedMessage
                    id={section?.main_title_description}
                    defaultMessage={section?.main_title_description}
                  />
                )}
              </div>
              <div>
                {section?.sections.map((content) => {
                  return (
                    <ul key={content} className="info-popup-content">
                      {content?.section_scope && (
                        <li className="info-popup-text">
                          <b>
                            <FormattedMessage
                              id={content?.section_scope}
                              defaultMessage={content?.section_scope}
                            />
                          </b>
                        </li>
                      )}
                      {content?.content.map((text) => {
                        return (
                          <li key={text} className="info-popup-text">
                            <FormattedMessage id={text} defaultMessage={text} />
                          </li>
                        );
                      })}
                    </ul>
                  );
                })}
              </div>
            </div>
          );
        })}
    </div>
  );
};

InfoPopup.propTypes = {
  mainTitle: PropTypes.string.isRequired,
  dataInfo: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

export default InfoPopup;
